export const MODIFIED_CELL_COLOR = '#0096D6'

export const makeModifiedCellStyle =
  <T>(
    getKey: (data?: T) => string | undefined,
    contextKey: 'modifiedPlCodes' | 'modifiedLineNumbers'
  ) =>
  (params: {
    node?: { rowPinned?: string | null; group?: boolean }
    data?: T
    context?: Record<string, Set<string> | undefined>
  }) => {
    if (params.node?.rowPinned || params.node?.group) return undefined
    const key = getKey(params.data)
    return key && params.context?.[contextKey]?.has(key)
      ? { color: MODIFIED_CELL_COLOR }
      : // Return an explicit color (not undefined) — AG Grid retains the previously
        // applied inline style when cellStyle returns undefined, leaving stale highlight.
        { color: 'inherit' }
  }
